import { Typogaphy } from 'vnetwork-ui'
import { NotificationItem } from '..'
import NotificationItemComp from './NotificationItem'
import { InView } from 'react-intersection-observer'
import { Loading } from 'vnetwork-ui'
import { useTranslation } from 'react-i18next'

interface PopupNotificationProps {
    notifications: NotificationItem[]
    handleClosePopup: () => void
    fetchNext: () => void
    isHasNextPage: boolean
    loading: boolean
    error: boolean
    limitCount: number
}

const PopupNotification: React.FC<PopupNotificationProps> = ({
    notifications,
    handleClosePopup,
    fetchNext,
    isHasNextPage,
    error,
    loading,
    // limitCount,
}) => {
    const { t } = useTranslation()

    return (
        <div className="w-[400px] max-w-full h-[450px] overflow-y-auto bg-white rounded-[8px] shadow-md flex flex-col">
            <Typogaphy
                size="medium"
                className="font-semibold p-4 border-b border-gray-100 sticky top-0 bg-white z-[10]"
            >
                {t('notification')}
            </Typogaphy>

            <div className="flex-1">
                {notifications?.map((n) => (
                    <NotificationItemComp
                        key={n?.id}
                        handleClosePopup={handleClosePopup}
                        item={n}
                    />
                ))}

                {error && (
                    <Typogaphy className="font-medium p-4">
                        {t('something-wrong')}
                    </Typogaphy>
                )}

                {loading && (
                    <div className="p-4">
                        <Loading.CircularProgress width={20} height={20} />
                    </div>
                )}

                {!error && !loading && notifications?.length === 0 && (
                    <Typogaphy className="font-medium p-4">
                        {t('notification-empty')}
                    </Typogaphy>
                )}
            </div>

            <InView
                fallbackInView
                onChange={(InVidew) => {
                    if (!loading && InVidew && isHasNextPage) {
                        fetchNext()
                    }
                }}
            >
                {({ ref }) => (
                    <div
                        ref={ref}
                        className="py-4 flex w-full items-center justify-center"
                    >
                        {loading && (
                            <Loading.CircularProgress width={20} height={20} />
                        )}
                    </div>
                )}
            </InView>
        </div>
    )
}

export default PopupNotification
